<backbone [currentPage]="'Home'">
  <header-page-title-box [title]="'Inicio'" [links]="[{title: 'Inicio'}]" />
  <div class="p-3">
    <section class="page-section p-3 bg-white rounded-2 shadow-sm">
      <p class="p-2 m-0">Home works!</p>
    </section>
  </div>
</backbone>